import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTelegram } from '../context/TelegramContext'
import Header from '../components/Header'
import './AdminProducts.css'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'

const AdminProducts = () => {
  const navigate = useNavigate()
  const { isAdmin, showAlert } = useTelegram()
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (isAdmin !== true) {
      showAlert?.('Доступ запрещён')
      navigate('/')
      return
    }
    loadProducts()
  }, [isAdmin])

  const loadProducts = async () => {
    try {
      setLoading(true)
      const response = await fetch(`${API_URL}/products`)
      const data = await response.json()
      setProducts(data)
      setError(null)
    } catch (err) {
      console.error('Ошибка загрузки товаров:', err)
      setError('Не удалось загрузить товары')
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = (productId) => {
    navigate(`/admin/products/edit/${productId}`)
  }

  const handleDelete = async (productId) => {
    if (!confirm('Удалить этот товар?')) return

    try {
      const response = await fetch(`${API_URL}/products/${productId}`, {
        method: 'DELETE'
      })
      
      if (response.ok) {
        showAlert?.('Товар удалён')
        loadProducts()
      } else {
        const errorData = await response.json().catch(() => ({}))
        console.error('Ошибка удаления:', errorData)
        showAlert?.('Ошибка удаления товара')
      }
    } catch (err) {
      console.error('Ошибка удаления:', err)
      showAlert?.('Ошибка удаления товара')
    }
  }

  const handleAdd = () => {
    navigate('/admin/products/add')
  }

  const getImageUrl = (imagePath) => {
    if (!imagePath) return '/placeholder.jpg'
    
    // Если путь начинается с http/https - используем как есть
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath
    }
    
    // Убираем лишние слэши и формируем правильный URL
    const cleanPath = imagePath.replace(/^\/+/, '')
    
    // В production используем текущий origin
    if (window.location.hostname !== 'localhost') {
      return `${window.location.origin}/${cleanPath}`
    }
    
    // В development используем API_URL без /api
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000/api'
    const baseUrl = apiUrl.replace('/api', '')
    return `${baseUrl}/${cleanPath}`
  }

  if (loading) {
    return (
      <div className="admin-products">
        <Header title="Управление товарами" showBack={true} />
        <div className="loading">Загрузка...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="admin-products">
        <Header title="Управление товарами" showBack={true} />
        <div className="error">{error}</div>
      </div>
    )
  }

  return (
    <div className="admin-products">
      <Header title="Управление товарами" showBack={true} />
      
      <div className="admin-products-container">
        <button className="btn-add-product" onClick={handleAdd}>
          ➕ Добавить товар
        </button>

        <div className="products-list">
          {products.map(product => (
            <div key={product.id} className="admin-product-item">
              <div className="admin-product-image">
                {product.image_url || product.image_urls ? (
                  <img 
                    src={(() => {
                      let imagePath = null
                      if (product.image_url) {
                        imagePath = product.image_url
                      } else if (product.image_urls) {
                        try {
                          const urls = typeof product.image_urls === 'string' ? JSON.parse(product.image_urls) : product.image_urls
                          imagePath = urls && urls.length > 0 ? urls[0] : null
                        } catch (e) {
                          console.error('Ошибка парсинга image_urls:', e)
                        }
                      }
                      return getImageUrl(imagePath)
                    })()} 
                    alt={product.name}
                    onError={(e) => {
                      console.error('Ошибка загрузки изображения:', e.target.src)
                      e.target.style.display = 'none'
                      e.target.parentElement.innerHTML = '<div class="placeholder">📷</div>'
                    }}
                  />
                ) : (
                  <div className="placeholder">📷</div>
                )}
              </div>
              
              <div className="admin-product-info">
                <h3>{product.name}</h3>
                <p className="product-desc">{product.description}</p>
                <div className="product-meta">
                  <span className="price">{product.price} ₽</span>
                  <span className="category">{product.category}</span>
                </div>
              </div>

              <div className="admin-product-actions">
                <button 
                  className="btn-images"
                  onClick={() => navigate(`/admin/products/images/${product.id}`)}
                  title="Управление изображениями"
                >
                  📸
                </button>
                <button 
                  className="btn-edit"
                  onClick={() => handleEdit(product.id)}
                  title="Редактировать"
                >
                  ✏️
                </button>
                <button 
                  className="btn-delete"
                  onClick={() => handleDelete(product.id)}
                  title="Удалить"
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AdminProducts





